import React from "react";

import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { Divider, Grid, Typography, useMediaQuery } from "@mui/material";
import AuthCardWrapper from "components/common/card/AuthCardWrapper.component";
import Logo from "components/logo/Logo";
import { Fragment } from "react";

const CardFormComponent = ({ title, subTitle, subButton, children }) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-end"
      sx={{ minHeight: "100vh" }}
    >
      <Grid item xs={12}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ minHeight: "100vh" }}
        >
          <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
            <AuthCardWrapper>
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
              >
                <Grid item sx={{ mb: 3 }}>
                  <Link to="#">
                    <Logo />
                  </Link>
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                    spacing={2}
                  >
                    {title && (
                      <Grid item xs={12}>
                        <Typography
                          color={theme.palette.secondary.main}
                          gutterBottom
                          variant={matchDownMD ? "h3" : "h2"}
                        >
                          {title}
                        </Typography>
                      </Grid>
                    )}
                    {subTitle && (
                      <Grid item xs={12}>
                        <Typography
                          variant="caption"
                          fontSize="16px"
                          textAlign="center"
                        >
                          {subTitle}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  {children}
                </Grid>

                {subButton && (
                  <Fragment>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>

                    <Grid item xs={12}>
                      <Grid
                        item
                        container
                        direction="column"
                        alignItems="center"
                        xs={12}
                      >
                        <Typography
                          component={Link}
                          to={subButton.href}
                          variant="subtitle1"
                          sx={{ textDecoration: "none" }}
                        >
                          {subButton.label}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Fragment>
                )}
              </Grid>
            </AuthCardWrapper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CardFormComponent;
